/**
 * Ends the page transition by removing the `page-transition` class from the `body` element.
 * Also clears any active timeout for hiding the loading state if it exists.
 *
 * @function
 * @returns {void}
 */
export const endPageTransition = () => {
  if (typeof window !== "undefined") {
    document.body.classList.remove("page-transition");
    if (window.hideLoading) {
      clearTimeout(window.hideLoading);
    }
  }
};

/**
 * Starts a page transition by adding the `page-transition` class to the `body` element.
 * Optionally sets a timeout to automatically end the transition after a default duration.
 *
 * @function
 * @param {boolean} [autoClose=true] - Determines if the transition should automatically end after a timeout.
 * @returns {void}
 */
export const startPageTransition = (autoClose = true, duration = 9000) => {
  if (typeof window !== "undefined") {
    document.body.classList.add("page-transition");
    if (window.hideLoading) {
      clearTimeout(window.hideLoading);
    }
    if (autoClose) {
      window.hideLoading = setTimeout(() => {
        endPageTransition();
      }, duration);
    }
  }
};
